import React from 'react';
import { getBrandImage } from '../data/brandImages';
import { PageHero } from './client/HomePage';
import { BrandStrip } from './client/ClientLayout';

const Field = ({ label, value }) => (
  <div>
    <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-maja-ink/40">{label}</p>
    <p className="mt-1 text-lg font-semibold text-maja-ink">{value || '—'}</p>
  </div>
);

const ClubProfile = ({
  userPoints,
  userName,
  userEmail,
  userLastName,
  userDni,
  userTelefono,
  userNacimiento,
  userDomicilio,
  siteConfig,
  setCurrentView,
}) => (
  <div>
    <PageHero
      image={getBrandImage(siteConfig, 'heroAyuda')}
      title={`${userName || ''} ${userLastName || ''}`.trim() || 'Mi cuenta'}
      subtitle="Tus datos de miembro de Maja Club."
      scripts={['Un club hecho para vos']}
    />

    <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="rounded-[1.8rem] bg-maja-ink text-white p-8 mb-6 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <p className="text-[11px] uppercase tracking-[0.22em] text-white/50">Puntos disponibles</p>
          <p className="font-display text-5xl mt-2">{Number(userPoints || 0).toLocaleString('es-AR')}</p>
        </div>
        {setCurrentView && (
          <button
            onClick={() => setCurrentView('canjes')}
            className="h-11 px-6 rounded-full bg-maja-red text-white font-semibold"
          >
            Canjear ahora
          </button>
        )}
      </div>

      <div className="rounded-[1.8rem] bg-white/80 border border-black/5 p-8">
        <h2 className="font-display text-3xl mb-6">Información personal</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6">
          <Field label="Nombre completo" value={`${userName || ''} ${userLastName || ''}`.trim()} />
          <Field label="Correo electrónico" value={userEmail} />
          <Field label="DNI" value={userDni} />
          <Field label="Teléfono" value={userTelefono} />
          <Field label="Fecha de nacimiento" value={userNacimiento} />
          <Field label="Domicilio" value={userDomicilio} />
        </div>
      </div>
    </section>

    {setCurrentView && (
      <BrandStrip
        setCurrentView={setCurrentView}
        title="Si necesitás actualizar un dato, escribinos y te ayudamos."
        cta="Ir a ayuda"
        target="help"
      />
    )}
  </div>
);

export default ClubProfile;
